import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import {MemberLayoutHoc } from '../_components';
import { userService } from '../_services';
import { LoadingBar } from './Loadingbar';

export class PrivateRoute extends React.Component {
    state = {
      loading: true,
      isAuthenticated: false,
    }

    componentDidMount() {
        if(localStorage.getItem('user') ){
            userService.checkAuth()
            .then(response => {
    
                //succesful call , update state 
                this.setState({
                    loading:false , 
                    isAuthenticated : true
                })
            })
        }
        else {
            //no login found
            this.setState({
                loading:false , 
                isAuthenticated : false
            })
        }
    }

    componentWillUnmount() {
    }

    render() {
      const { component: Component, ...rest } = this.props;

      if (this.state.loading) {
        return <LoadingBar />;
      } 
      else {
        return (
            <Route
                {...rest}
                render={ props =>
                    this.state.isAuthenticated ? (
                        <Component {...props} />
                    ) : 
                    (
                        this.state.loading ? (
                            <LoadingBar />
                        ) : 
                        (
                            <Redirect to={{ pathname: '/login', state: { from: this.props.location } }} />
                        )
                    )
                }
            />
        )
      }
    }
  }




// WEBPACK FOOTER //
// ./src/_components/PrivateRoute.jsx